import { Component, Vue } from 'vue-property-decorator'
import { Getter, Mutation } from 'vuex-class'

import ApiRequest from '@/core/ApiRequest'
import AccessModel from '@/core/models/AccessModel'
import { GET_ACCESS_MODEL, GET_API_REQUEST, GET_CLIENT_LAST_SEARCH_QUERY } from '@/store/root/getters'
import { SET_CLIENT_LAST_SEARCH_QUERY } from '@/store/root/mutations'


@Component
export default class Clients extends Vue {
  public query: string = ''
  public clients: Array<any> = []

  /**
   * Get api request object, based on global Vuex state.
   */
  @Getter(GET_API_REQUEST)
  public getApiRequest: ApiRequest

  /**
   * Get last search query, based on global Vuex state.
   */
  @Getter(GET_CLIENT_LAST_SEARCH_QUERY)
  public getLastSearchQuery: string

  /**
   * Sets last search query state.
   */
  @Mutation(SET_CLIENT_LAST_SEARCH_QUERY)
  public setLastSearchQuery: (query: string) => void


  /**
   * Get access model, based on global Vuex state.
   */
  @Getter(GET_ACCESS_MODEL)
  public getAccessModel: AccessModel | null

  /**
   * Show clients events.
   */
  public eventsOfClient (id: string) {
    console.log(`eventsOfClient(${id})`)
    this.$router.push({
      name: 'clientEvents',
      params: { id },
    })
  }

  /**
   * Search for users.
   */
  public async search () {
    await this.fetchClients()
  }

  private async fetchClients () {
    this.setLastSearchQuery(this.query)

    const response = await this.getApiRequest.send(
      'GET',
      'clients?search=' +
      encodeURIComponent(this.query ? this.query : ''),
    )
    if (!response || !response.data) {
      this.clients = []
      return
    }
    this.clients = response.data
  }

  /**
   * Created lifecycle hook. Fires when component instance is created.
   */
  public async created () {
    if (!this.getAccessModel || !this.getAccessModel.user) { return }
    this.query = this.getLastSearchQuery
    await this.fetchClients()
  }
}
